import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PaymentProviderContainerModel } from "../../../../../models/aggregates/pgw/payment-provider-container.model";
import {
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
  PagingResponseModel,
} from "../shared";

@Injectable({
  providedIn: "root",
})
export class PaymentProviderService extends BaseApiTemplateService<PaymentProviderContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.PGW_PREFIX +
      "payment-providers";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.PGW_PREFIX +
      "payment-providers";
    this.httpClient = http;
  }

  addImageAndDetails(formData: FormData, paymentProviderGuid, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + "/file/" + paymentProviderGuid + "/upload";
    return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }

  replaceImageAndDetails(formData: FormData, extGuid, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + "/replace-file/" + extGuid;
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  getImageDetails(extGuid, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + "/file/" + extGuid;
    return this.httpClient.get(url, this.getHttpHeader(visa));
  }

  deleteImageDetails(extGuid, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + "/file/" + extGuid;
    return this.httpClient.delete(url, this.getHttpHeader(visa));
  }
}
